/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPTRANSFERMETHOD = {
    Cash: 'CASH',
    Units: 'UNITS'
} as const;
export type IAPTRANSFERMETHOD = typeof IAPTRANSFERMETHOD[keyof typeof IAPTRANSFERMETHOD];


export function IAPTRANSFERMETHODFromJSON(json: any): IAPTRANSFERMETHOD {
    return IAPTRANSFERMETHODFromJSONTyped(json, false);
}

export function IAPTRANSFERMETHODFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPTRANSFERMETHOD {
    return json as IAPTRANSFERMETHOD;
}

export function IAPTRANSFERMETHODToJSON(value?: IAPTRANSFERMETHOD | null): any {
    return value as any;
}

